function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}

const titleMixin = {
  mounted() {
    const title = getTitle(this);
    if (title) {
      document.title = `${title} — ITC Finance Web Admin`;
    }
  },
};

export default titleMixin;
